/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1334
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ClaimCouponCodes } from '../model/models';
import { CouponCounts } from '../model/models';
import { CouponDto } from '../model/models';
import { CreateCouponBatchDto } from '../model/models';
import { CreateCouponDto } from '../model/models';
import { MinimalCoupon } from '../model/models';
import { PaginatedCoupons } from '../model/models';
import { UpdateCouponDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    CouponServiceInterface,
    CouponControllerClaimAndDownloadCodesRequestParams,
    CouponControllerCreateCouponBatchRequestParams,
    CouponControllerDeleteCouponRequestParams,
    CouponControllerDownloadCouponCodesRequestParams,
    CouponControllerGetCouponByIdRequestParams,
    CouponControllerGetCouponCountsRequestParams,
    CouponControllerGetCouponsRequestParams,
    CouponControllerRemoveUnclaimedCodesRequestParams,
    CouponControllerSearchCouponsRequestParams,
    CouponControllerStoreCouponRequestParams,
    CouponControllerUpdateCouponRequestParams
} from './coupon.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CouponService implements CouponServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerClaimAndDownloadCodes(requestParameters: CouponControllerClaimAndDownloadCodesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public couponControllerClaimAndDownloadCodes(requestParameters: CouponControllerClaimAndDownloadCodesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public couponControllerClaimAndDownloadCodes(requestParameters: CouponControllerClaimAndDownloadCodesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public couponControllerClaimAndDownloadCodes(requestParameters: CouponControllerClaimAndDownloadCodesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const claimCouponCodes = requestParameters.claimCouponCodes;
        if (claimCouponCodes === null || claimCouponCodes === undefined) {
            throw new Error('Required parameter claimCouponCodes was null or undefined when calling couponControllerClaimAndDownloadCodes.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerClaimAndDownloadCodes.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerClaimAndDownloadCodes.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/codes/claim`,
            claimCouponCodes,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerCreateCouponBatch(requestParameters: CouponControllerCreateCouponBatchRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CouponDto>;
    public couponControllerCreateCouponBatch(requestParameters: CouponControllerCreateCouponBatchRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CouponDto>>;
    public couponControllerCreateCouponBatch(requestParameters: CouponControllerCreateCouponBatchRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CouponDto>>;
    public couponControllerCreateCouponBatch(requestParameters: CouponControllerCreateCouponBatchRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const createCouponBatchDto = requestParameters.createCouponBatchDto;
        if (createCouponBatchDto === null || createCouponBatchDto === undefined) {
            throw new Error('Required parameter createCouponBatchDto was null or undefined when calling couponControllerCreateCouponBatch.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerCreateCouponBatch.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerCreateCouponBatch.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<CouponDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/batches`,
            createCouponBatchDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerDeleteCoupon(requestParameters: CouponControllerDeleteCouponRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public couponControllerDeleteCoupon(requestParameters: CouponControllerDeleteCouponRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public couponControllerDeleteCoupon(requestParameters: CouponControllerDeleteCouponRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public couponControllerDeleteCoupon(requestParameters: CouponControllerDeleteCouponRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerDeleteCoupon.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerDeleteCoupon.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerDownloadCouponCodes(requestParameters: CouponControllerDownloadCouponCodesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public couponControllerDownloadCouponCodes(requestParameters: CouponControllerDownloadCouponCodesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public couponControllerDownloadCouponCodes(requestParameters: CouponControllerDownloadCouponCodesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public couponControllerDownloadCouponCodes(requestParameters: CouponControllerDownloadCouponCodesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerDownloadCouponCodes.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerDownloadCouponCodes.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/codes`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerGetCouponById(requestParameters: CouponControllerGetCouponByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CouponDto>;
    public couponControllerGetCouponById(requestParameters: CouponControllerGetCouponByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CouponDto>>;
    public couponControllerGetCouponById(requestParameters: CouponControllerGetCouponByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CouponDto>>;
    public couponControllerGetCouponById(requestParameters: CouponControllerGetCouponByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerGetCouponById.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerGetCouponById.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<CouponDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerGetCouponCounts(requestParameters: CouponControllerGetCouponCountsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CouponCounts>;
    public couponControllerGetCouponCounts(requestParameters: CouponControllerGetCouponCountsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CouponCounts>>;
    public couponControllerGetCouponCounts(requestParameters: CouponControllerGetCouponCountsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CouponCounts>>;
    public couponControllerGetCouponCounts(requestParameters: CouponControllerGetCouponCountsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerGetCouponCounts.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerGetCouponCounts.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<CouponCounts>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/counts`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerGetCoupons(requestParameters: CouponControllerGetCouponsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PaginatedCoupons>;
    public couponControllerGetCoupons(requestParameters: CouponControllerGetCouponsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PaginatedCoupons>>;
    public couponControllerGetCoupons(requestParameters: CouponControllerGetCouponsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PaginatedCoupons>>;
    public couponControllerGetCoupons(requestParameters: CouponControllerGetCouponsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const limit = requestParameters.limit;
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling couponControllerGetCoupons.');
        }
        const page = requestParameters.page;
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling couponControllerGetCoupons.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerGetCoupons.');
        }
        const searchTerm = requestParameters.searchTerm;
        const status = requestParameters.status;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }
        if (searchTerm !== undefined && searchTerm !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>searchTerm, 'search_term');
        }
        if (status) {
            status.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'status');
            })
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<PaginatedCoupons>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerRemoveUnclaimedCodes(requestParameters: CouponControllerRemoveUnclaimedCodesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CouponDto>;
    public couponControllerRemoveUnclaimedCodes(requestParameters: CouponControllerRemoveUnclaimedCodesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CouponDto>>;
    public couponControllerRemoveUnclaimedCodes(requestParameters: CouponControllerRemoveUnclaimedCodesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CouponDto>>;
    public couponControllerRemoveUnclaimedCodes(requestParameters: CouponControllerRemoveUnclaimedCodesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerRemoveUnclaimedCodes.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerRemoveUnclaimedCodes.');
        }
        const batchId = requestParameters.batchId;
        if (batchId === null || batchId === undefined) {
            throw new Error('Required parameter batchId was null or undefined when calling couponControllerRemoveUnclaimedCodes.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<CouponDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}/batches/${encodeURIComponent(String(batchId))}/unclaimed`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerSearchCoupons(requestParameters: CouponControllerSearchCouponsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<MinimalCoupon>>;
    public couponControllerSearchCoupons(requestParameters: CouponControllerSearchCouponsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<MinimalCoupon>>>;
    public couponControllerSearchCoupons(requestParameters: CouponControllerSearchCouponsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<MinimalCoupon>>>;
    public couponControllerSearchCoupons(requestParameters: CouponControllerSearchCouponsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerSearchCoupons.');
        }
        const searchTerm = requestParameters.searchTerm;
        if (searchTerm === null || searchTerm === undefined) {
            throw new Error('Required parameter searchTerm was null or undefined when calling couponControllerSearchCoupons.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (searchTerm !== undefined && searchTerm !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>searchTerm, 'search_term');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<MinimalCoupon>>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/search`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerStoreCoupon(requestParameters: CouponControllerStoreCouponRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public couponControllerStoreCoupon(requestParameters: CouponControllerStoreCouponRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public couponControllerStoreCoupon(requestParameters: CouponControllerStoreCouponRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public couponControllerStoreCoupon(requestParameters: CouponControllerStoreCouponRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        const createCouponDto = requestParameters.createCouponDto;
        if (createCouponDto === null || createCouponDto === undefined) {
            throw new Error('Required parameter createCouponDto was null or undefined when calling couponControllerStoreCoupon.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerStoreCoupon.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons`,
            createCouponDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public couponControllerUpdateCoupon(requestParameters: CouponControllerUpdateCouponRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CouponDto>;
    public couponControllerUpdateCoupon(requestParameters: CouponControllerUpdateCouponRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CouponDto>>;
    public couponControllerUpdateCoupon(requestParameters: CouponControllerUpdateCouponRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CouponDto>>;
    public couponControllerUpdateCoupon(requestParameters: CouponControllerUpdateCouponRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateCouponDto = requestParameters.updateCouponDto;
        if (updateCouponDto === null || updateCouponDto === undefined) {
            throw new Error('Required parameter updateCouponDto was null or undefined when calling couponControllerUpdateCoupon.');
        }
        const programId = requestParameters.programId;
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling couponControllerUpdateCoupon.');
        }
        const couponId = requestParameters.couponId;
        if (couponId === null || couponId === undefined) {
            throw new Error('Required parameter couponId was null or undefined when calling couponControllerUpdateCoupon.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<CouponDto>(`${this.configuration.basePath}/v1/programs/${encodeURIComponent(String(programId))}/coupons/${encodeURIComponent(String(couponId))}`,
            updateCouponDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
